import { axiosApiInstance } from '@/utils/axios';
import config from '../config';

const MetricController = {
  async getMetricChildren(parentId, childType, maxDepth) {
    try {
      const params = {
        id: parentId,
        maxdepth: maxDepth,
      };
      if (childType !== undefined) {
        params.childtype = childType;
      }

      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/children2`, { params });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getMetricChildren2(parentId, childType, maxDepth, filter, project) {
    try {
      const params = {
        id: parentId,
        maxdepth: maxDepth,
        filter: JSON.stringify(filter),
      };
      if (childType !== undefined) {
        params.childtype = childType;
      }
      if (project !== undefined) {
        params.project = JSON.stringify(project);
      }

      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/children2`, { params });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getPartCounts(parentId, filter) {
    try {
      const params = {
        id: parentId,
        filter: JSON.stringify(filter),
      };
      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/partCounts`, { params });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getAssetCounts(parentId, aggkey, filter) {
    try {
      const params = {
        id: parentId,
        aggkey,
        filter: JSON.stringify(filter),
      };
      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/assetCounts2`, { params });

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getMetricAggregate(parentId, childType, maxDepth, filter, aggkey) {
    try {
      const params = {
        id: parentId,
        maxdepth: maxDepth,
        filter: JSON.stringify(filter),
      };
      if (childType !== undefined) {
        params.childtype = childType;
        params.aggkey = aggkey;
      }

      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/aggregate`, { params });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async lookupSpherical(inspectionUUID, path) {
    try {
      const { data } = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/sphericalmap`, {
        params: { path, inspection_uuid: inspectionUUID },
      });
      return data;
    } catch (error) {
      return { error: `Unable to retrieve spherical: ${error.message}` };
    }
  },

  async getMetricParents(parentId) {
    try {
      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/parents`, { params: { id: parentId } });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getMetricData(id) {
    try {
      const { data } = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/data`, { params: { id } });
      return data;
    } catch (error) {
      return { error: `Unable to get metric data: ${error.message}` };
    }
  },

  async getReferringImages(inspectionUUID, tag) {
    try {
      const response = await axiosApiInstance.get(`${config.apiPath}/v1/metrics/refimages`, {
        params: { inspection_uuid: inspectionUUID, tag },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  async getExternalSystem(platformId, system, tag) {
    try {
      const { data } = await axiosApiInstance.get(
        `${config.apiPath}/v2/platforms/${platformId}/assemblies/by-integration`,
        {
          params: { system, tag },
        }
      );
      return data;
    } catch (error) {
      return { error: `Unable to retrieve external system: ${error.message}` };
    }
  },
};

export default MetricController;
